export const generateLearnMoreLink = (locale: string = 'en') => {
  return `https://support.wix.com/${locale}/article/about-team-management`;
};

export const generateTeamMembersListLearnMoreLink =  (isSite: boolean, locale: string = 'en') => {
  if (isSite) {
    return `https://support.wix.com/${locale}/article/about-roles-permissions-contributors`;
  } else {
    return `https://support.wix.com/${locale}/article/about-team-management`;
  }
};

export const generateManageRolesLearnMoreLink = (isSite: boolean, locale: string = 'en') => {
  if (isSite) {
    return `https://support.wix.com/${locale}/article/managing-your-sites-roles`;
  } else {
    return `https://support.wix.com/${locale}/article/about-team-management`;
  }
};

export const generateInvitePeopleLearnMoreLink = (isSite: boolean, locale: string = 'en') => {
  if (isSite) {
    return `https://support.wix.com/${locale}/article/inviting-site-contributors`;
  } else {
    return `https://support.wix.com/${locale}/article/about-team-management`;
  }
};

export const generateUpgradeLink = (msid: string): string => `https://www.wix.com/store/plans?v=1&siteGuid=${msid}&referralAdditionalInfo=bizMgrSidebar`;
